import { all } from "redux-saga/effects";
import {
  productBarcodeWatcher,
  productBarcodesWatcher,
  productCreateWatcher,
  productCreateFromBillingWatcher,
  productDeleteWatcher,
  productEditWatcher,
  productInventoryCreateWatcher,
  productPlanningCreateWatcher,
  productPurchasingCreateWatcher,
  productRemarksCreateWatcher,
  productRestrictionCreateWatcher,
  productSalesCreateWatcher,
  productTableWatcher,
  productViewWatcher,
  productGenerateItemCodeWatcher,
  productVerifyItemCodeWatcher,
  productDisCreateWatcher,
  productPackingCreateWatcher,
} from "../product-saga";

export default function* productRootSaga() {
  yield all([
    productCreateWatcher(),
    productCreateFromBillingWatcher(),
    productTableWatcher(),
    productPurchasingCreateWatcher(),
    productSalesCreateWatcher(),
    productInventoryCreateWatcher(),
    productPackingCreateWatcher(),
    productPlanningCreateWatcher(),
    productDisCreateWatcher(),
    productRestrictionCreateWatcher(),
    productRemarksCreateWatcher(),
    productViewWatcher(),
    productEditWatcher(),
    productDeleteWatcher(),
    productBarcodeWatcher(),
    productBarcodesWatcher(),
    productGenerateItemCodeWatcher(),
    productVerifyItemCodeWatcher(),
  ]);
}
